import { render, staticRenderFns } from "./discordInvite.vue?vue&type=template&id=486906eb&"
import script from "./discordInvite.vue?vue&type=script&lang=js&"
export * from "./discordInvite.vue?vue&type=script&lang=js&"
import style0 from "./discordInvite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports